import { render, staticRenderFns } from "./QuoteList.vue?vue&type=template&id=25e4bb14&scoped=true"
import script from "./QuoteList.vue?vue&type=script&lang=js"
export * from "./QuoteList.vue?vue&type=script&lang=js"
import style0 from "./QuoteList.vue?vue&type=style&index=0&id=25e4bb14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e4bb14",
  null
  
)

export default component.exports